import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewResidueCategory, updateResidueCategory } from '../../../../slices/residueCategory/thunk';
import { setRequireCloseModal } from '../../../../slices/residueCategory/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getResidueTypeList } from '../../../../helpers/residue/backend_helper';
// import { getResidueCategoryTypeList } from '../../../../helpers/residue/backend_helper';

const ResidueCategoryForm = ({
	dataResidueCategory,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

    const [selectedResidueType, setSelectedResidueType] = useState(null);
    const handleResidueTypeSelected = (optionSelected) => {
        setSelectedResidueType(optionSelected);
    };

    const [disabledCheck, setDisabledCheck] = useState(dataResidueCategory.disable);

	const selectorResidueCategory = createSelector(
		state => state.ResidueCategories,
		residueCategory => ({
			isAdding: residueCategory.isAdding,
			isAdded: residueCategory.isAdded,
			isUpdating: residueCategory.isUpdating,
			isUpdated: residueCategory.isUpdated,
			isLoadingList: residueCategory.isLoadingList,
			requireCloseModal: residueCategory.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorResidueCategory);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            name: dataResidueCategory.name || '',
		},
		validationSchema: Yup.object({
            name: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedResidueCategory = {
					_id: dataResidueCategory._id,
                    residue_type_id: (selectedResidueType?.item?._id ? selectedResidueType.item._id : ''),
                    name: values.name,
                    disabled: disabledCheck
				};
				dispatch(updateResidueCategory(updatedResidueCategory));
			} else {
				const newResidueCategory = {
					residue_type_id: (selectedResidueType?.item?._id ? selectedResidueType.item._id : ''),
                    name: values.name,
                    disabled: disabledCheck
				};
				dispatch(addNewResidueCategory(newResidueCategory));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
                            <Col lg={12}>
								<Label for='name' className='form-label'>
									Nombre
								</Label>
								<Input
									name='name'
									id='name'
									className='form-control'
									placeholder='Ingrese un nombre'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name || ''}
									invalid={
										validation.touched.name &&
										validation.errors.name
											? true
											: false
									}
								/>
								{
                                    validation.touched.name &&
                                    validation.errors.name ? (
                                        <FormFeedback type='invalid'>
                                            {validation.errors.name}
                                        </FormFeedback>
                                    ) : null
                                }
							</Col>
                            <Col lg={12}>
                                <GeneralSelect
                                    label='Tipo de Residuo'
                                    value={{_id: dataResidueCategory.residue_type_id} || ''}
                                    className={''}
                                    // invalid={validation.touched.x && validation.errors.x ? true : false}
                                    // error={validation.errors.x}
                                    onSelect={handleResidueTypeSelected}
                                    requestApi={getResidueTypeList}
                                    params={{}}
                                    disabled={false}
                                />
                            </Col>
                            <div className='d-flex gap-3 pt-3'>
                                <div>
                                    {isEdit && (
                                        <FormGroup className='d-flex align-items-center'>
                                            <Label className=''>
                                                <div className='d-flex'>
                                                    <Input
                                                        type="checkbox"
                                                        checked={disabledCheck}
                                                        onChange={(e) => setDisabledCheck(e.target.checked)}
                                                    />
                                                    <div className='px-1'>
                                                        ¿Normativa inactiva?
                                                    </div>
                                                </div>
                                            </Label>
                                            {validation.touched.disabled &&
                                            validation.errors.disabled ? (
                                                <FormFeedback type='invalid'>
                                                    {validation.errors.disabled}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    )}
                                </div>
                            </div>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Categoría de Residuo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ResidueCategoryForm;
